var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13832_48104",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13832_48104)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5735 18.5207C30.8452 12.784 25.9335 8.33398 20.0002 8.33398C15.4068 8.33398 11.4168 11.019 9.59516 15.2507C6.01516 16.3207 3.3335 19.7007 3.3335 23.334C3.3335 27.929 7.07183 31.6673 11.6668 31.6673H16.6668H18.3335H21.6668H23.3335H30.0002C33.6768 31.6673 36.6668 28.6773 36.6668 25.0007C36.6668 21.8673 34.4918 19.2307 31.5735 18.5207V18.5207ZM21.6668 23.3345V28.3344H18.3335V23.3345H13.3335L20.0002 15.0011L26.6668 23.3345H21.6668V23.3345Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud_upload.6ecbe3d096ef88040b425177e6956642.svg";
export { ForwardRef as ReactComponent };